import { COLORS } from '../../../utils/colors';

export const useImageStyles = () => {
  return {
    resetReport: {
      marginLeft: 'auto',
      textTransform: 'capitalize',
      textDecoration: 'underline',
      color: COLORS.RED,
      fontSize: '12px',
    },
    imagesPanel: {
      paddingTop: '2rem',
      padding: '1rem',
      overflowY: 'auto',
      height: 'calc(100vh - 5.8rem)',
      borderTop: `1px solid #ebebeb`,
      marginTop: '-1px',
      backgroundColor: 'white',
    },
    savedScreenshotWrapper: {
      display: 'flex',
      borderRadius: '.625rem',
      height: '15rem',
      width: '15rem',
      backgroundColor: 'rgba(255, 255, 0, 0)',
      position: 'relative',
    },
    savedScreenshot: {
      display: 'block',
      transition: '0.5s ease',
      borderRadius: '.625rem',
      objectFit: 'cover',
      width: '6rem',
      margin: '.75rem',
    },
    imageOverlay: {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
    },
    iconTray: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    trayButton: {
      cursor: 'pointer',
      borderRadius: '.25rem',
      padding: '.25rem',
      marginRight: '1rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '2rem',
      height: '2rem',
      color: '#888',
      '&:hover': {
        backgroundColor: '#f3f3f3',
      },
    },
    imagePreview: {
      position: 'relative',
      margin: 'auto',
      objectFit: 'contain',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      '& img': {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
        margin: 'auto',
      },
    },
    dimensions: {
      position: 'absolute',
      bottom: 8,
      right: 8,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      color: '#fff',
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontFamily: 'monospace',
      zIndex: 1,
    },
    imageDescription: {
      position: 'absolute',
      top: 0,
      right: 0,
      width: '1rem',
      height: '1rem',
      backgroundColor: 'orange',
      borderRadius: '50%',
      margin: '.25rem',
    },
    imgPreview: {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
    },
  };
};
